<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="toc" role="doc-toc">
<h1 id="toc-title">Putting on the Style</h1>
<ol class="toc">
<li>
<span href="#/text/cover" title="Link target outside of Sample">Cover</span>
</li>
<li id="title_page">
<a href="#/text/title_page">Title Page</a>
</li>
<li id="toc-li-1">
<a href="#/text/ch001#chapter-one">Chapter One</a>
<ol class="toc">
<li id="toc-li-2">
<a href="#/text/ch001#section">1953</a>
</li>
</ol>
</li>
<li id="toc-li-3">
<a href="#/text/ch002#chapter-two">Chapter Two</a>
</li>
<li id="toc-li-4">
<a href="#/text/ch003#chapter-three">Chapter Three</a>
</li>
<li id="toc-li-5">
<a href="#/text/ch004#chapter-four">Chapter Four</a>
</li>
<li id="toc-li-6">
<a href="#/text/ch005#chapter-five">Chapter Five</a>
</li>
<li id="toc-li-7">
<span href="#/text/ch006#chapter-six" title="Link target outside of Sample">Chapter Six</span>
</li>
<li id="toc-li-8">
<span href="#/text/ch007#chapter-seven" title="Link target outside of Sample">Chapter Seven</span>
</li>
<li id="toc-li-9">
<span href="#/text/ch008#chapter-eight" title="Link target outside of Sample">Chapter Eight</span>
</li>
<li id="toc-li-10">
<span href="#/text/ch009#chapter-nine" title="Link target outside of Sample">Chapter Nine</span>
</li>
<li id="toc-li-11">
<span href="#/text/ch010#chapter-ten" title="Link target outside of Sample">Chapter Ten</span>
</li>
<li id="toc-li-12">
<span href="#/text/ch011#chapter-eleven" title="Link target outside of Sample">Chapter Eleven</span>
</li>
<li id="toc-li-13">
<span href="#/text/ch012#chapter-twelve" title="Link target outside of Sample">Chapter Twelve</span>
</li>
<li id="toc-li-14">
<span href="#/text/ch013#chapter-thirteen" title="Link target outside of Sample">Chapter Thirteen</span>
</li>
<li id="toc-li-15">
<span href="#/text/ch014#chapter-fourteen" title="Link target outside of Sample">Chapter Fourteen</span>
</li>
<li id="toc-li-16">
<span href="#/text/ch015#chapter-fifteen" title="Link target outside of Sample">Chapter Fifteen</span>
</li>
<li id="toc-li-17">
<span href="#/text/ch016#chapter-sixteen" title="Link target outside of Sample">Chapter Sixteen</span>
</li>
<li id="toc-li-18">
<span href="#/text/ch017#chapter-seventeen" title="Link target outside of Sample">Chapter Seventeen</span>
</li>
<li id="toc-li-19">
<span href="#/text/ch018#chapter-eighteen" title="Link target outside of Sample">Chapter Eighteen</span>
</li>
<li id="toc-li-20">
<span href="#/text/ch019#chapter-nineteen" title="Link target outside of Sample">Chapter Nineteen</span>
</li>
<li id="toc-li-21">
<span href="#/text/ch020#chapter-twenty" title="Link target outside of Sample">Chapter Twenty</span>
</li>
<li id="toc-li-22">
<span href="#/text/ch021#chapter-twenty-one" title="Link target outside of Sample">Chapter Twenty-One</span>
</li>
<li id="toc-li-23">
<span href="#/text/ch022#chapter-twenty-two" title="Link target outside of Sample">Chapter Twenty-Two</span>
</li>
<li id="toc-li-24">
<span href="#/text/ch023#chapter-twenty-three" title="Link target outside of Sample">Chapter Twenty-Three</span>
</li>
<li id="toc-li-25">
<span href="#/text/ch024#chapter-twenty-four" title="Link target outside of Sample">Chapter Twenty-Four</span>
</li>
<li id="toc-li-26">
<span href="#/text/ch025#chapter-twenty-five" title="Link target outside of Sample">Chapter Twenty-Five</span>
</li>
<li id="toc-li-27">
<span href="#/text/ch026#chapter-twenty-six" title="Link target outside of Sample">Chapter Twenty-Six</span>
</li>
<li id="toc-li-28">
<span href="#/text/ch027#chapter-twenty-seven" title="Link target outside of Sample">Chapter Twenty-Seven</span>
</li>
<li id="toc-li-29">
<span href="#/text/ch028#chapter-twenty-eight" title="Link target outside of Sample">Chapter Twenty-Eight</span>
</li>
<li id="toc-li-30">
<span href="#/text/ch029#chapter-twenty-nine" title="Link target outside of Sample">Chapter Twenty-Nine</span>
</li>
<li id="toc-li-31">
<span href="#/text/ch030#chapter-thirty" title="Link target outside of Sample">Chapter Thirty</span>
</li>
<li id="toc-li-32">
<span href="#/text/ch031#chapter-thirty-one" title="Link target outside of Sample">Chapter Thirty-One</span>
</li>
<li id="toc-li-33">
<span href="#/text/ch032#chapter-thirty-two" title="Link target outside of Sample">Chapter Thirty-Two</span>
</li>
<li id="toc-li-34">
<span href="#/text/ch033#chapter-thirty-three" title="Link target outside of Sample">Chapter Thirty-Three</span>
</li>
<li id="toc-li-35">
<span href="#/text/ch034#chapter-thirty-four" title="Link target outside of Sample">Chapter Thirty-Four</span>
</li>
<li id="toc-li-36">
<span href="#/text/ch035#chapter-thirty-five" title="Link target outside of Sample">Chapter Thirty-Five</span>
</li>
<li id="toc-li-37">
<span href="#/text/ch036#chapter-thirty-six" title="Link target outside of Sample">Chapter Thirty-Six</span>
</li>
<li id="toc-li-38">
<span href="#/text/ch037#chapter-thirty-seven" title="Link target outside of Sample">Chapter Thirty-Seven</span>
</li>
<li id="toc-li-39">
<span href="#/text/ch038#chapter-thirty-eight" title="Link target outside of Sample">Chapter Thirty-Eight</span>
</li>
<li id="toc-li-40">
<span href="#/text/ch039#chapter-thirty-nine" title="Link target outside of Sample">Chapter Thirty-Nine</span>
</li>
<li id="toc-li-41">
<span href="#/text/ch040#chapter-forty" title="Link target outside of Sample">Chapter Forty</span>
</li>
<li id="toc-li-42">
<span href="#/text/ch041#chapter-forty-one" title="Link target outside of Sample">Chapter Forty-One</span>
</li>
<li id="toc-li-43">
<span href="#/text/ch042#chapter-forty-two" title="Link target outside of Sample">Chapter Forty-Two</span>
</li>
<li id="toc-li-44">
<span href="#/text/ch043#chapter-forty-three" title="Link target outside of Sample">Chapter Forty-Three</span>
</li>
<li id="toc-li-45">
<span href="#/text/ch044#chapter-forty-four" title="Link target outside of Sample">Chapter Forty-Four</span>
</li>
<li id="toc-li-46">
<span href="#/text/ch045#chapter-forty-five" title="Link target outside of Sample">Chapter Forty-Five</span>
</li>
<li id="toc-li-47">
<span href="#/text/ch046#chapter-forty-six" title="Link target outside of Sample">Chapter Forty-Six</span>
</li>
<li id="toc-li-48">
<span href="#/text/ch047#chapter-forty-seven" title="Link target outside of Sample">Chapter Forty-Seven</span>
</li>
<li id="toc-li-49">
<span href="#/text/ch048#chapter-forty-eight" title="Link target outside of Sample">Chapter Forty-Eight</span>
</li>
<li id="toc-li-50">
<span href="#/text/ch049#chapter-forty-nine" title="Link target outside of Sample">Chapter Forty-Nine</span>
</li>
<li id="toc-li-51">
<span href="#/text/ch050#next-in-series" title="Link target outside of Sample">Next in Series</span>
</li>
<li class="author_bio">
<span href="#/text/author_bio" title="Link target outside of Sample">About the Author</span>
</li>
<li class="also_by">
<span href="#/text/also_by" title="Link target outside of Sample">Also by Freda Lightfoot</span>
</li>
<li id="toc-li-52">
<span href="#/text/ch051#copyright" title="Link target outside of Sample">Copyright</span>
</li>
</ol>
</nav>
<nav epub:type="landmarks" hidden="hidden" id="landmarks">
<ol>
<li>
<span epub:type="cover" href="#/text/cover" title="Link target outside of Sample">Cover</span>
</li>
<li>
<a epub:type="toc" href="#/nav#toc">Table of Contents</a>
</li>
<li>
<a epub:type="bodymatter" href="#/text/title_page">Start of Content</a>
</li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?29b2184e